module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Informações Básicas da Empresa")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.account.taxIdNumberFormatted),
      expression: "account.taxIdNumberFormatted",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:18|cnpj|accountExists:cnpj'),
      expression: "'required|max:18|cnpj|accountExists:cnpj'"
    }, {
      name: "mask-cnpj",
      rawName: "v-mask-cnpj"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "pattern": "^([A-Za-z0-9]{2}\\.[A-Za-z0-9]{3}\\.[A-Za-z0-9]{3}\\/[A-Za-z0-9]{4}-[0-9]{2}|[A-Za-z0-9]{12}[0-9]{2})$",
      "id": "taxIdNumber",
      "name": "taxIdNumber",
      "title": "cpnj",
      "readonly": _vm.blockTaxIdNumber,
      "data-vv-validate-on": "blur",
      "placeholder": "00.000.000/0000-00"
    },
    domProps: {
      "value": (_vm.account.taxIdNumberFormatted)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.account, "taxIdNumberFormatted", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("taxIdNumber")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('companyName')
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.companyName),
      expression: "account.company.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "companyName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account.company.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("companyName")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('companyTradeName')
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.companyTradeName),
      expression: "account.company.companyTradeName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "companyTradeName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account.company.companyTradeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "companyTradeName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("companyTradeName")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:20'),
      expression: "'max:20'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.companyStateIdNumber),
      expression: "account.company.companyStateIdNumber"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "state-registration",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account.company.companyStateIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "companyStateIdNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('activity-branch')
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.businessActivity),
      expression: "account.company.businessActivity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "activity-branch"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account.company, "businessActivity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.businessActivities), function(b) {
    return _c('option', {
      domProps: {
        "value": b.value
      }
    }, [_vm._v("\n                  " + _vm._s(b.label) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("activity-branch")) + "\n              ")]), _vm._v(" "), (_vm.businessActivity == 'OUTRAS') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('activity-branch2')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherActivity),
      expression: "otherActivity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "form-control margin-t10",
    attrs: {
      "type": "text",
      "name": "activity-branch2"
    },
    domProps: {
      "value": (_vm.otherActivity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherActivity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.first("activity-branch2")) + "\n                ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.site),
      expression: "account.company.site"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "site",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account.company.site)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "site", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_c('div', {
    staticClass: "fleet-switch"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "onoffswitch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optanteNacional),
      expression: "optanteNacional"
    }],
    staticClass: "onoffswitch-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "round-switch"
    },
    domProps: {
      "checked": Array.isArray(_vm.optanteNacional) ? _vm._i(_vm.optanteNacional, null) > -1 : (_vm.optanteNacional)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.optanteNacional,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.optanteNacional = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.optanteNacional = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.optanteNacional = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(7)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Representante Legal")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.legalRepName),
      expression: "account.company.legalRepName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:80'),
      expression: "'required|max:80'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account.company.legalRepName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "legalRepName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("name")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('cpf')
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.account.company.legalRepTaxpayerId),
      expression: "account.company.legalRepTaxpayerId",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpf'),
      expression: "'required|cpf'"
    }, {
      name: "mask-cpf",
      rawName: "v-mask-cpf"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "taxIdNumberCPF",
      "name": "cpf",
      "title": "cpf",
      "maxlength": "11",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.account.company.legalRepTaxpayerId)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.account.company, "legalRepTaxpayerId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("cpf")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('rg-number')
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:14'),
      expression: "'required|max:14'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.legalRepresentativeNationalIdNumber),
      expression: "account.company.legalRepresentativeNationalIdNumber"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "rg-number",
      "type": "text",
      "placeholder": "Número"
    },
    domProps: {
      "value": (_vm.account.company.legalRepresentativeNationalIdNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-number")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('rg-orgao')
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:10'),
      expression: "'required|max:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.legalRepresentativeNationalIdIssuer),
      expression: "account.company.legalRepresentativeNationalIdIssuer"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "rg-orgao",
      "type": "text",
      "placeholder": "Orgão expedidor",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.account.company.legalRepresentativeNationalIdIssuer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdIssuer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-orgao")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('rg-state')
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.legalRepresentativeNationalIdState),
      expression: "account.company.legalRepresentativeNationalIdState"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "rg-state"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account.company, "legalRepresentativeNationalIdState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.states), function(e) {
    return _c('option', {
      domProps: {
        "value": e.sigla
      }
    }, [_vm._v("\n                  " + _vm._s(e.sigla) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("rg-state")) + "\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Gestor de Contrato")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('manager-name')
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.contractManagerFullName),
      expression: "account.company.contractManagerFullName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "manager-name",
      "name": "manager-name",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.account.company.contractManagerFullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "contractManagerFullName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("manager-name")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.accountAuthentication.login),
      expression: "account.accountAuthentication.login"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "email",
      "title": "email",
      "placeholder": "Ex: nome@empresa.com.br",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.account.accountAuthentication.login)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.accountAuthentication, "login", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("email")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.company.contractManagerJobTitle),
      expression: "account.company.contractManagerJobTitle"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "text",
      "name": "role",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.account.company.contractManagerJobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.company, "contractManagerJobTitle", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification"
  }, [_vm._v("Telefones de Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "form-group margin-b30 input-box-control"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel1),
      expression: "tel1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cell'),
      expression: "'required|cell'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "telephone1",
      "id": "telephone1",
      "placeholder": "(00) 00000-0000",
      "type": "text",
      "maxlength": "14",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.tel1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone1")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('telephone2')
    }
  }, [_c('div', {
    staticClass: "label-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.typePhone),
      expression: "account.typePhone"
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "telephoneType2",
      "name": "telephoneType2",
      "data-unique-phone": "telephone2"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account, "typePhone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CELULAR"
    }
  }, [_vm._v("Celular")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COMERCIAL"
    }
  }, [_vm._v("Comercial")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel2),
      expression: "tel2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone' | 'cell'),
      expression: "'phone' | 'cell'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "telephone2",
      "id": "telephone2",
      "placeholder": "(00) 0000-0000",
      "type": "text",
      "maxlength": "14",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.tel2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone2")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group margin-b30 input-box-control",
    class: {
      'has-error': _vm.errors.has('telephone3')
    }
  }, [_c('div', {
    staticClass: "label-box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.typePhone2),
      expression: "account.typePhone2"
    }],
    staticClass: "form-control small",
    attrs: {
      "id": "telephoneType3",
      "name": "telephoneType3",
      "data-unique-phone": "telephone3"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account, "typePhone2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CELULAR"
    }
  }, [_vm._v("Celular")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COMERCIAL"
    }
  }, [_vm._v("Comercial")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tel3),
      expression: "tel3"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "telephone3",
      "id": "telephone3",
      "placeholder": "(00) 0000-0000",
      "type": "text",
      "maxlength": "14",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.tel3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel3 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("telephone3")) + "\n              ")])]), _vm._v(" "), _vm._t("default")], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Segurança")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group input-box-control margin-pass",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:20|moveMaisCPF'),
      expression: "'required|min:8|max:20|moveMaisCPF'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.accountAuthentication.password),
      expression: "account.accountAuthentication.password"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "title": "senha",
      "maxlength": "20",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.account.accountAuthentication.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.accountAuthentication, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("password")) + "\n                  ")])])]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group margin-b10 input-box-control",
    class: {
      'has-error': _vm.errors.has('confirm-password')
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:20|confirmed:password'),
      expression: "'required|min:8|max:20|confirmed:password'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account.accountAuthentication.confirmPassword),
      expression: "account.accountAuthentication.confirmPassword"
    }],
    staticClass: "form-control small",
    attrs: {
      "type": "password",
      "id": "confirm-password",
      "name": "confirm-password",
      "title": "confirmar senha",
      "maxlength": "20",
      "data-vv-validate-on": "blur"
    },
    domProps: {
      "value": (_vm.account.accountAuthentication.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account.accountAuthentication, "confirmPassword", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n                    " + _vm._s(_vm.errors.first("confirm-password")) + "\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('address-comp', {
    ref: "addressMailing",
    attrs: {
      "address": _vm.address,
      "type": "MAILING"
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CNPJ:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Razão social:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome fantasia:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Inscrição Estadual:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Ramo de Atividade:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Site:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Optante Pelo Simples Nacional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "onoffswitch-label",
    attrs: {
      "for": "round-switch"
    }
  }, [_c('span', {
    staticClass: "onoffswitch-inner"
  }), _vm._v(" "), _c('span', {
    staticClass: "onoffswitch-switch"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("CPF:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("RG:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Orgão Expedidor:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Estado:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Nome completo:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("E-mail:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Cargo:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('select', {
    staticClass: "form-control small",
    attrs: {
      "id": "telephoneType1",
      "name": "telephoneType1",
      "data-unique-phone": "telephone1"
    }
  }, [_c('option', {
    attrs: {
      "value": "CELULAR"
    }
  }, [_vm._v("Celular*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Senha:*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                  Senha deve ter de 8 a 20 caracteres\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                  Senha deve ter pelo menos um número\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                  Senha deve ter uma letra maiúscula\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "box-dicas"
  }, [_vm._v("\n                  Senha deve ter um caractere especial\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-box"
  }, [_c('label', [_vm._v("Confirme a Senha:*")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-29ddc2b9!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/adhesion/company-data.vue
// module id = 2079
// module chunks = 1